import { render, staticRenderFns } from "./page-form.vue?vue&type=template&id=6780ce9e"
import script from "./page-form.vue?vue&type=script&lang=js"
export * from "./page-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports